// src/components/home/AboutSection.jsx
import {React, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

// About images
import image4 from '../../assets/about1.png';
import image5 from '../../assets/about2.png';
import imagebg from '../../assets/about2-bg.png';
import imagebg2 from '../../assets/about1-bg.png';
import FloatingMortar from '../common/FloatingMortar';


const AboutSection = () => {
    // Add this inside AboutSection.jsx (at the bottom, before return or after imports)
useEffect(() => {
  const cards = document.querySelectorAll(".about-parallax-card");

  const range = 40;
  const calcValue = (a, b) => (a / b * range - range / 2).toFixed(1);
  let timeout;

  const handleMouseMove = (e) => {
    if (timeout) window.cancelAnimationFrame(timeout);
    timeout = window.requestAnimationFrame(() => {
      const yValue = calcValue(e.clientY, window.innerHeight);
      const xValue = calcValue(e.clientX, window.innerWidth);

      cards.forEach(card => {
        card.style.transform = `rotateX(${yValue}deg) rotateY(${xValue}deg)`;

        const img = card.querySelector(".about-parallax-card__img");
        const bg = card.querySelector(".about-parallax-card__bg");

        if (img) {
          img.style.transform = `
            translateX(${-xValue * 1.5}px)
            translateY(${yValue * 1.5}px)
            translateZ(60px)
          `;
        }
        if (bg) {
          bg.style.backgroundPosition = `
            ${xValue * 0.3}px
            ${-yValue * 0.3}px
          `;
        }
      });
    });
  };

  document.addEventListener("mousemove", handleMouseMove);
  return () => document.removeEventListener("mousemove", handleMouseMove);
}, []);



  const navigate = useNavigate();

  return (
    <section id="about" className="bg-[#E4D7C2] py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-8 font-playfair overflow-hidden relative">
      {/* THIS IS ALL YOU NEED – YOUR WAY 
          <div className="absolute -top-16 -left-16 z-10 pointer-events-none
                      w-40 h-40 sm:w-80 sm:h-80 md:w-[500px] md:h-[500px] lg:w-[580px] lg:h-[580px]">
        <FloatingMortar />
      </div>*/}
  {/* Top Badges */}
  <div className="about-badges flex flex-col items-center gap-3 sm:gap-4 mb-12 sm:mb-16 md:mb-20">
    <div className="badge inline-block border border-[#0B2A2C] text-[#0B2A2C] px-4 sm:px-6 py-2 rounded-full text-xl mb-4 sm:mb-6"> About</div>
  </div>

  <div className="flex flex-col sm:flex-row justify-center items-center gap-10 sm:gap-20 -mt-6 sm:-mt-10">
    <div className="badge bg-[#F9F5DB] text-[[#0B2A2C]] w-40 h-10 sm:w-44 sm:h-12 flex items-center justify-center rounded-full text-sm font-medium shadow-sm">
      Panchakarma Therapy
    </div>
    <div className="badge bg-[#F9F5DB] text-[[#0B2A2C]] w-40 h-10 sm:w-44 sm:h-12 flex items-center justify-center rounded-full text-sm font-medium shadow-sm">
      Herbal Treatments
    </div>
  </div>

 <div
  className="
    about-content 
    flex flex-col                   /* Mobile: stack */
    md:flex-row                     /* Desktop: row */
    justify-center items-center
    max-w-[1400px] mx-auto

    gap-6 sm:gap-8 md:gap-14 lg:gap-20 xl:gap-24
    px-4 sm:px-6 md:px-0

    mt-8 sm:mt-10 md:mt-16

    scale-90 sm:scale-95 md:scale-100  /* 🔥 Shrink on mobile */
    text-sm sm:text-base md:text-lg    /* Adjust text too */
  "
>

    {/* Left Circular Image with Enhanced Pop-out Effect */}
    <div className="about-left flex-1 flex justify-center ">
      <div className="relative group scale-50 sm:scale-95 md:scale-50 xl2:scale-100">
        {/* Background Container with subtle shadow */}
        {/* <div className="absolute inset-0 bg-[#D4C8B0] rounded-full transform translate-y-4 translate-x-4 group-hover:translate-y-6 group-hover:translate-x-6 transition-all duration-300"></div> */}
        
        {/* Main Image with Pop-out */}
        <div className="about-parallax-card about-parallax-card-circular ">
          <div
            className="about-parallax-card__bg "
            style={{
              backgroundImage: `url(${imagebg2})`,
              backgroundPosition: 'center 15%',
              width : '200px',
              height : '200px',
            }}
          />
          <img
            src={image4}
            alt="Panchakarma therapy session"
            className="about-parallax-card__img "
            style={{ objectPosition: 'center 15%',width : '200px',
              height : '200px', transform: 'translateZ(40px)'  }}
          />
        </div>
      </div>
    </div>

    {/* Center Text - Enhanced spacing and alignment */}
    <div className="about-center flex-1 lg:flex-[1.3] text-center px-2 sm:px-4 md:px-0">
      <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black-900 mb-6 sm:mb-8 leading-snug max-w-[650px] mx-auto ">
        Rejuvenate Your<br />Body, Restore<br />Your Inner Balance
      </h2>
      <p className="text-sm sm:text-base md:text-lg text-black-700 leading-[1.6] mb-8 sm:mb-10 font-light max-w-xl mx-auto">
        Experience holistic healing with traditional Ayurveda therapies that nurture your body, mind, and soul.
      </p>
      <button
        onClick={() => navigate("/about")}
        className="solox-btn bg-[#0B2A2C] text-white hover:text-[#0B2A2C] border-2 border-[#0B2A2C] px-8 sm:px-10 py-4 sm:py-4 rounded-full text-base sm:text-lg transition-all duration-300 hover:bg-green-950 hover:shadow-lg hover:-translate-y-1"
      >
        <span>Explore More</span>
      </button>
    </div>

    {/* Right Doctor Image + Stats - Enhanced alignment */}
    <div className="about-right flex-1 flex justify-center md:justify-end ">
      <div className="relative doctor-stats flex flex-col xs:gap-0 xs:scale-15 sm:flex-row items-center md:items-start gap-8 sm:gap-10 scale-90 md:gap-0 md:scale-100 sm:scale-95 tb:scale-100 lg:scale-100 xl2:gap-20 xl2:scale-70 xl2:top-[-55px]">
        <div className="relative group scale-50 md:scale-150 sm:scale-95 xs:objects-contain xl2:scale-100 tb:scale-100 tb:items-start md:top-[20%] lg:scale-100 xl2:scale-100">
          {/* Background Container */}
          {/* <div className="absolute inset-0 bg-[#D4C8B0] rounded-2xl transform translate-y-3 translate-x-3 group-hover:translate-y-5 group-hover:translate-x-5 transition-all duration-300"></div> */}
          
          {/* Main Image */}
          <div className="about-parallax-card  ">
            <div
              className="about-parallax-card__bg"
              style={{
                backgroundImage: `url(${imagebg})`,
                backgroundPosition: 'center 10%',
                
              }}
            />
            <img
              src={image5}
              alt="Ayurveda doctor holding herbs"
              className="about-parallax-card__img "
              style={{ objectPosition: 'center 12%' }}
            />
          </div>
        </div>

        {/* Stats - Enhanced spacing */}
        <div className="stats flex flex-col gap-4 sm:gap-5 md:gap-6 text-center xl2:scale-100 md:scale-50 md:text-left mt-4 sm:mt-0">
          <div className="stat flex items-center gap-3">
            <span className="stat-icon text-3xl"></span>
            <div className="flex flex-col">
              <span className="stat-number text-3xl sm:text-4xl font-bold">50+</span>
              <span className="stat-label text-xs sm:text-sm text-black-700 whitespace-nowrap">Authentic Therapies</span>
            </div>
          </div>
          <div className="stat flex items-center gap-3">
            <span className="stat-icon text-3xl"></span>
            <div className="flex flex-col">
              <span className="stat-number text-3xl sm:text-4xl font-bold">10k+</span>
              <span className="stat-label text-xs sm:text-sm text-black-700 whitespace-nowrap">Healed Patients</span>
            </div>
          </div>
          <div className="stat flex items-center gap-3">
            <span className="stat-icon text-3xl"></span>
            <div className="flex flex-col">
              <span className="stat-number text-3xl sm:text-4xl font-bold">98%</span>
              <span className="stat-label text-xs sm:text-sm text-black-700 whitespace-nowrap">Patient Satisfaction</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  );
};

export default AboutSection;